// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatAutoCleanupSettings__content-a1490f {
  padding: 0 24px;
  flex: 1;
}

.ChatAutoCleanupSettings__tip-ff49f1 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
  padding-top: 6px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatAutoCleanupSettings/ChatAutoCleanupSettings.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,OAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,gBAAA;AACF","sourcesContent":[".content {\n  padding: 0 24px;\n  flex: 1;\n}\n\n.tip {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n  padding-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `ChatAutoCleanupSettings__content-a1490f`,
	"tip": `ChatAutoCleanupSettings__tip-ff49f1`
};
module.exports = ___CSS_LOADER_EXPORT___;
